import * as React from 'react';
import {Header} from '..';
import CustomText from '../../components/CustomText.styled';
import Icon from '../../components/Icon';
import QuestionContentWrapper from '../../components/QuestionContentWrapper';
import SpaceLike from '../../components/Space';
import {useResultStore} from '../../store/responses';
import {
  QuestionManualContent,
  ResultQuestions,
  SelectManualProps,
} from '../../types/questionManuals';
import QuestionManualFour from './QuestionManualFour';
import QuestionManualOne from './QuestionManualOne';
import QuestionManualResult from './QuestionManualResult';
import QuestionManualThree from './QuestionManualThree';
import QuestionManualTwo from './QuestionManualTwo';

export interface IQuestionManualProps {
  goBackManual: () => void;
  currentQuestionManual: QuestionManualContent;
  skipQuestionManual: () => void;
  handleNextStepManual: () => void;
  handleSelectManual: (data: SelectManualProps) => void;
  handleResetQuestion: () => void;
  resultsManual: ResultQuestions[];
}

export const QuestionManual = ({
  goBackManual,
  currentQuestionManual,
  skipQuestionManual,
  handleNextStepManual,
  handleSelectManual,
  handleResetQuestion,
  resultsManual,
}: IQuestionManualProps) => {
  const {result} = useResultStore();
  const renderQuestionManual = (
    currentQuestionManual: QuestionManualContent,
  ) => {
    switch (currentQuestionManual.step) {
      case 1:
        return (
          <QuestionManualOne
            currentQuestion={currentQuestionManual}
            handleNextStep={handleNextStepManual}
            handleSelect={handleSelectManual}
          />
        );
      case 2:
        return (
          <QuestionManualTwo
            currentQuestion={currentQuestionManual}
            handleNextStep={handleNextStepManual}
            handleSelect={handleSelectManual}
            results={resultsManual}
          />
        );
      case 3:
        return (
          <QuestionManualThree
            currentQuestion={currentQuestionManual}
            handleNextStep={handleNextStepManual}
            handleSelect={handleSelectManual}
            results={resultsManual}
          />
        );
      case 4:
        return (
          <QuestionManualFour
            currentQuestion={currentQuestionManual}
            handleNextStep={handleNextStepManual}
            handleSelect={handleSelectManual}
            results={resultsManual}
            carData={result.q2_your_vehicle}
          />
        );
      case 5:
        return (
          <QuestionManualResult
            {...currentQuestionManual}
            handleNextStep={handleNextStepManual}
            results={resultsManual}
            handleResetQuestion={handleResetQuestion}
          />
        );
      default:
        return null;
    }
  };
  return (
    <>
      <Header style={{alignItems: 'center'}}>
        {' '}
        <SpaceLike direction="horizontal">
          <Icon icon="arrow-back" size={16} />
          <CustomText
            onClick={goBackManual}
            color="white"
            style={{textDecoration: 'underline', cursor: 'pointer'}}
          >
            Back
          </CustomText>
        </SpaceLike>
      </Header>
      <QuestionContentWrapper
        title={currentQuestionManual?.title}
        maxWidthContent={currentQuestionManual.step === 5 ? '800px' : '400px'}
        maxWidthTitle={'800px'}
        hiddenButton
        skipQuestion={skipQuestionManual}
      >
        {renderQuestionManual(currentQuestionManual)}
      </QuestionContentWrapper>
    </>
  );
};
